/**
 * @param {string | number} value 사업자등록번호
 * @returns {string} 문자열
 * @description 사업자등록번호를 nnn-nn-nnnnn의 형태로 반환합니다.
 */
export const formatCorpNumber = (value: string | number) => {
  return String(value).replace(/^(\d{3})(\d{2})(\d{5})$/, `$1-$2-$3`);
};
